export const chatBubbleTypes = {
  received: "received",
  sent: "sent",
} as const;

export const chatBubbleSizes = {
  default: "default",
  small: "small",
} as const;
